module.exports = __webpack_public_path__ + "static/media/checkmarkGreen.74af8b97.svg";